import { SetStateAction, useState } from 'react';
import { toast } from 'react-toastify';
import { useAccount } from 'wagmi';

import { useUpdateReferralWalletV2Mutation } from '@/store/services/project.service';

import { ReferralWalletHook } from '../types/referralWallet.type';

const useReferralWalletV2 = (): ReferralWalletHook => {
  const { address } = useAccount();
  const [updateReferralWallet] = useUpdateReferralWalletV2Mutation();

  const handleUpdateReferralWallet = async ({
    nft,
    referral,
    signature,
    setErrorMessage,
    onSuccess,
    onHide,
    setIsConfirmingTrue,
    setIsConfirmingFalse,
  }: {
    nft: string;
    referral: string;
    signature: string;
    setErrorMessage: (value: SetStateAction<string>) => void;
    onSuccess: () => void;
    onHide: () => void;
    setIsConfirmingTrue: () => void;
    setIsConfirmingFalse: () => void;
  }) => {
    setIsConfirmingTrue();
    try {
      const response = await updateReferralWallet({ nft, referralCode: referral, signature, address });
      if (response.data?.isError) {
        setErrorMessage(response.data.errorMessage || 'Invalid referral code');
        return;
      }
      toast.success('Referral code added successfully');
      onSuccess();
      onHide();
    } catch (error) {
      throw error;
    } finally {
      setIsConfirmingFalse();
    }
  };

  return { handleUpdateReferralWallet };
};

export { useReferralWalletV2 };
